import { render, staticRenderFns } from "./StudentDegrees.vue?vue&type=template&id=4e06a658"
import script from "./StudentDegrees.vue?vue&type=script&lang=js"
export * from "./StudentDegrees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports